import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CashiersPageRoutingModule } from './cashiers-routing.module';

import { CashiersPage } from './cashiers.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CashiersPageRoutingModule
  ],
  declarations: [CashiersPage]
})
export class CashiersPageModule {}
